const firebaseConfig = {
  apiKey: "AIzaSyCR0qHryE1ki4nZw7d3a9n-C8E7wBkXMZQ",
  authDomain: "test.mobiry.jp",
  databaseURL: "https://mobiry-stg.firebaseio.com",
  projectId: "mobiry-stg",
  storageBucket: "mobiry-stg.appspot.com",
};

export default firebaseConfig;
